import { NodeRendererProps, Tree } from 'react-arborist';
import { useCallback, useContext, useMemo } from 'react';
import { TmsContext } from '../TmsContext';
import { findOuById } from '@app/sdk';
import { OrganisationUnit, TenantHierarchy } from '@app/models';

export function TenantHierarchyTree(props: { organisationHierarchy: TenantHierarchy }) {
  const { setSelectedOu } = useContext(TmsContext);
  const { organisationHierarchy } = props;

  const getTreeFromOrganisationUnit = useCallback((organisationUnit: OrganisationUnit) => {
    return {
      name: organisationUnit.name,
      id: organisationUnit.id,
      children: organisationUnit.children.map(getTreeFromOrganisationUnit),
      attributes: {
        label: organisationUnit.label,
      },
    };
  }, []);

  const treeData = useMemo(() => {
    return getTreeFromOrganisationUnit(organisationHierarchy.organisationUnit);
  }, [getTreeFromOrganisationUnit, organisationHierarchy.organisationUnit]);

  const setSelectedOuFromHierarchy = (organisationUnit: OrganisationUnit) => {
    const ou = findOuById(organisationHierarchy.organisationUnit, organisationUnit.id);
    setSelectedOu(ou);
  };

  return (
    <div id="treeWrapper">
      <Tree
        initialData={[treeData]}
        disableDrag={true}
        onSelect={(node) => setSelectedOuFromHierarchy((node[0] && node[0].data) || {})}>
        {Node}
      </Tree>
    </div>
  );
}

function Node({ node, style }: NodeRendererProps<any>) {
  style = {
    cursor: 'pointer',
    background: 'transparent',
    border: 'none',
    whiteSpace: 'nowrap',
    ...(node.isSelected && { background: '#c7e0f4' }),
    ...style,
  };

  function toggleOpenClose() {
    if (node.isOpen) {
      node.close();
    } else {
      node.open();
    }
  }

  /* This node instance can do many things. See the API reference. */
  return (
    <button style={style}>
      <span onClick={() => toggleOpenClose()}>{node.isClosed ? '🗀' : '📂'}</span>
      <span style={{ paddingLeft: '10px' }}>{node.data.name}</span>
    </button>
  );
}
